// =======================================
// core/init-app.js
// “起動処理” を共通化する（domReady はエントリ側の責務）
//
// 役割:
// - reduced-motion を HTML に反映（CSSでも参照できる）
// - modules/components を読み込み（register させる）
// - data-module / data-component をスキャンして起動（registry.init）
//
// 注意:
// - ここは「いつ init するか」を決めない（待ち合わせ/順番は entry 側で組む）
// =======================================

import { prefersReducedMotion } from "./prefers-reduced-motion.js";
import { registry } from "./registry.js";
import { createHeader } from "../modules/header/header.js";
import { createDrawer } from "../components/drawer/Drawer.js";

// 登録
registry.registerModule("header", ({ root }) => createHeader(root));
registry.registerComponent("drawer", ({ el }) => createDrawer(el));

/**
 * modules / components を起動する。
 *
 * @param {ParentNode} [root=document] 起点DOM（document / element など）
 */
export function initApp(root = document) {
  // root が不正でも落ちないように保険（基本は document が来る想定）
  const safeRoot =
    root && typeof root.querySelectorAll === "function" ? root : document;

  // reduced-motion を HTML に反映（CSSでも参照できる）
  const reduced = prefersReducedMotion();
  document.documentElement.classList.toggle("is-reduced-motion", reduced);

  // data-module / data-component をスキャンして起動
  registry.init(safeRoot);
}
